import { BlockRenderer, type Block, type StreamingBlock } from "@storytell/streaming";
import type { ParentComponent } from "solid-js";
import { BlockContentContainer } from "./BlockContentContainer";
import { BlockHeaderPill } from "./BlockHeaderPill";
import { copyBlockDebugInfoToClipboard } from "./blockDebugUtils";
import { getBlockIconComponent } from "./blockIcons";

interface BaseBlockPreviewProps {
  block: StreamingBlock;
  onClick: () => void;
  variant?: "blue" | "purple";
}

export const BaseBlockPreview: ParentComponent<BaseBlockPreviewProps> = (props) => {
  const title = () => props.block.title || props.block.activity || "Content";
  const variant = () => props.variant || "blue";

  const handleCopyDebugInfo = async (e: MouseEvent) => {
    e.stopPropagation();
    await copyBlockDebugInfoToClipboard(props.block);
  };

  return (
    <div class="group w-full">
      <BlockHeaderPill
        title={title()}
        icon={getBlockIconComponent(props.block, BlockRenderer.BLOCK_PREVIEW, { variant: variant() })}
        isProcessing={!props.block.isComplete}
        onClick={props.onClick}
        onCopyDebugInfo={handleCopyDebugInfo}
        variant={variant()}
      />

      {/* Parent components using this handle their own content subscriptions */}
      <BlockContentContainer hasContent={true}>{props.children}</BlockContentContainer>
    </div>
  );
};
